/** @example ```typescript
 * pluralise(1, 'person', 'people') // person
 * `...in ${numDays} ${pluralise(numDays, 'day', 'days')}`
 * ```
 */
export function pluralise(quantity: number | undefined, singular: string, plural?: string) {
   if (typeof quantity === 'undefined') {
      return undefined
   }
   return quantity === 1 ? singular : (plural ?? `${singular}s`)
}


export function toSentenceCase(str: string): string {
   if (!str) return ''
   return str.charAt(0).toUpperCase() + str.slice(1)
}

/** Strip markdown formatting characters for plain-text preview */
export function stripMarkdown(md: string): string {
   return md.replace(/#{1,6}\s?/g, '')
      .replace(/\*{1,2}([^*]+)\*{1,2}/g, '$1')
      .replace(/_{1,2}([^_]+)_{1,2}/g, '$1')
      .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1')
      .replace(/[`~>-]/g, '')
      .replace(/\n+/g, ' ')
      .trim()
}